// Davlat sektori qarzi statistikasi — admin qismi.
// Backend kontrakti: CONSOLE.md + JAVOBLAR.md (2026-08-17).
//
// Spek pathlarni `{API_HOST}/v1/psds-calendar/...` deb yozadi; bu consolda
// hamma endpoint `api/v1/...` ostida (http instance baseURL = VUE_APP_BASE_API_URL).
//
// Muhim kontrakt xususiyatlari (JAVOBLAR.md):
//  - GET list -> XOM MASSIV, o'ram yo'q, paginatsiya yo'q, bo'sh natija `[]`.
//  - POST -> {message, id} — yangi id qaytadi.
//  - PUT -> TO'LIQ ALMASHTIRISH, PATCH yo'q. Yuborilmagan maydon default'ga
//    tushadi (`is_active` -> true!), shuning uchun har doim to'liq payload.
//  - Admin GET til fallback QILMAYDI — bo'sh til bo'sh string bo'lib keladi.
import http from "@/http";

export const API_BASE = "api/v1/psds-calendar";

export default {
  // ---- Davriyliklar ----
  periodicities() {
    return http.get(`${API_BASE}/periodicities`).then(({ data }) => data || []);
  },
  periodicity(id) {
    return http.get(`${API_BASE}/periodicities/${id}`).then(({ data }) => data);
  },
  createPeriodicity(payload) {
    return http.post(`${API_BASE}/periodicities`, payload);
  },
  updatePeriodicity(id, payload) {
    return http.put(`${API_BASE}/periodicities/${id}`, payload);
  },
  deletePeriodicity(id) {
    return http.delete(`${API_BASE}/periodicities/${id}`);
  },

  // ---- Ma'lumot turlari ----
  datasets() {
    return http.get(`${API_BASE}/datasets`).then(({ data }) => data || []);
  },
  dataset(id) {
    return http.get(`${API_BASE}/datasets/${id}`).then(({ data }) => data);
  },
  createDataset(payload) {
    return http.post(`${API_BASE}/datasets`, payload);
  },
  updateDataset(id, payload) {
    return http.put(`${API_BASE}/datasets/${id}`, payload);
  },
  deleteDataset(id) {
    return http.delete(`${API_BASE}/datasets/${id}`);
  },

  // ---- Hodisalar ----
  // Paginatsiya yo'q: filtrsiz so'rov hamma yilning hamma eventini tortadi,
  // shuning uchun `year` doim berilsin (CONSOLE.md §6).
  events(params) {
    return http.get(`${API_BASE}/events`, { params }).then(({ data }) => data || []);
  },
  event(id) {
    return http.get(`${API_BASE}/events/${id}`).then(({ data }) => data);
  },
  createEvent(payload) {
    return http.post(`${API_BASE}/events`, payload);
  },
  updateEvent(id, payload) {
    return http.put(`${API_BASE}/events/${id}`, payload);
  },
  deleteEvent(id) {
    return http.delete(`${API_BASE}/events/${id}`);
  },

  // ---- Vositalar ----
  generate(payload) {
    return http.post(`${API_BASE}/generate`, payload).then(({ data }) => data);
  },
  copyYear(payload) {
    return http.post(`${API_BASE}/copy-year`, payload).then(({ data }) => data);
  },
  // Public `/years` 5 daqiqa keshlanadi va nofaol yozuvlar yilini ko'rsatmaydi —
  // admin panel shu keshlanmaydigan variantni ishlatadi (JAVOBLAR.md B4).
  adminYears() {
    return http.get(`${API_BASE}/admin/years`).then(({ data }) => data?.years || []);
  },
};

// ---- Ko'p tillilik ----

export const LANG_KEYS = ["uz_lat", "uz_cyr", "ru", "en", "kr"];

export const LANG_LABELS = {
  uz_lat: "O'zbekcha (lotin)",
  uz_cyr: "Ўзбекча (кирилл)",
  ru: "Русский",
  en: "English",
  kr: "Qoraqalpoqcha",
};

export const LANG_TABS = [
  { code: "uz_lat", tabLabel: "UZ" },
  { code: "uz_cyr", tabLabel: "UZ Krill" },
  { code: "ru", tabLabel: "RU" },
  { code: "en", tabLabel: "EN" },
  { code: "kr", tabLabel: "KR" },
];

export function emptyMultiLang() {
  return LANG_KEYS.reduce((acc, key) => {
    acc[key] = "";
    return acc;
  }, {});
}

export function fillMultiLang(source) {
  return LANG_KEYS.reduce((acc, key) => {
    acc[key] = source?.[key] || "";
    return acc;
  }, {});
}

// Jadval katagi uchun bitta satr. Admin GET fallback qilmagani uchun bu
// faqat konsol ko'rinishi — portal o'z fallback zanjirini qo'llaydi.
export function displayLangText(multiLang) {
  if (!multiLang) return "";
  return (
    multiLang.uz_lat || multiLang.uz_cyr || multiLang.ru || multiLang.en || multiLang.kr || ""
  );
}

export function hasAnyLang(multiLang) {
  return LANG_KEYS.some((key) => !!multiLang?.[key]);
}

// ---- Oylar ----

export const MONTH_NAMES_FULL = [
  "Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun",
  "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr",
];

export const MONTH_NAMES_SHORT = [
  "Yan", "Fev", "Mar", "Apr", "May", "Iyn",
  "Iyl", "Avg", "Sen", "Okt", "Noy", "Dek",
];

export const ALL_MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const QUARTER_MONTHS = [1, 4, 7, 10];

export function monthName(month, short = false) {
  const names = short ? MONTH_NAMES_SHORT : MONTH_NAMES_FULL;
  return names[month - 1] || String(month);
}

// Backend `day_from` ni oyga nisbatan tekshiradi va kabisa yilini hisobga
// oladi (JAVOBLAR.md B7). Shu tekshiruvni UI ham qiladi — admin saqlashdan
// oldin bilib tursin.
export function lastDayOfMonth(year, month) {
  if (!year || !month) return 31;
  return new Date(year, month, 0).getDate();
}

// `day_to` ataylab tekshirilmaydi: u ko'rsatiladigan diapazon oxiri, real
// sana emas (fevralda ham "1-31" yozish mumkin).
export function dayExistsInMonth(year, month, day) {
  if (!year || !month || !day) return true;
  return day <= lastDayOfMonth(year, month);
}

// Badge matni: "15" yoki diapazon uchun "1-31".
export function dayLabel(dayFrom, dayTo) {
  return dayTo && dayTo !== dayFrom ? `${dayFrom}-${dayTo}` : String(dayFrom ?? "");
}

// ---- Enum'lar ----

export const YEAR_MIN = 1900;
export const YEAR_MAX = 2200;

export const REPORT_PERIOD_MODES = [
  {
    value: "prev_month",
    label: "Oldingi oy",
    hint: "Yanvar -> «Dekabr oyi uchun (2025 yil)», Fevral -> «Yanvar oyi uchun»",
  },
  {
    value: "prev_quarter",
    label: "Oldingi chorak",
    hint: "Yan/Fev/Mar -> «4-chorak uchun (2025 yil)», Apr/May/Iyn -> «1-chorak uchun»",
  },
  {
    value: "prev_year",
    label: "Oldingi yil",
    hint: "Hamma oyda «2025 yil uchun»",
  },
  {
    value: "custom",
    label: "O'z matnim",
    hint: "Quyida kiritilgan matn hamma oyga bir xil yoziladi",
  },
  {
    value: "none",
    label: "Matnsiz",
    hint: "Hisobot davri yozilmaydi",
  },
];

// Davriylik rangi uchun tayyor palitra. Migratsiyadagi 4 ta davriylik rangi
// (monthly/quarterly/annual/daily) birinchi to'rttasi.
export const COLOR_PALETTE = [
  "#3B82F6", "#F59E0B", "#EF4444", "#22C55E",
  "#0EA5E9", "#7C3AED", "#DB2777", "#F97316",
  "#14B8A6", "#64748B",
];

export const DEFAULT_COLOR = "#3B82F6";

// Backend `#RGB` va `#RRGGBB` ni qabul qiladi, registr farqi yo'q.
export const COLOR_PATTERN = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

// `^[a-z0-9_-]{1,32}$` — portal filtri (`?periodicity=<code>`) shu kod bilan
// ishlagani uchun URL-safe bo'lishi shart.
export const CODE_PATTERN = /^[a-z0-9_-]{1,32}$/;
export const CODE_MAX_LENGTH = 32;

// ---- Ranglar ----

// Badge foni to'q bo'lsa oq matn, och bo'lsa qora matn.
export function contrastTextColor(hex) {
  const normalized = normalizeHex(hex);
  if (!normalized) return "#FFFFFF";
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 165 ? "#1F2937" : "#FFFFFF";
}

// `#38F` -> `#3388FF`, aks holda null.
export function normalizeHex(hex) {
  const value = String(hex || "").trim();
  if (!COLOR_PATTERN.test(value)) return null;
  if (value.length === 4) {
    return `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`.toUpperCase();
  }
  return value.toUpperCase();
}

// ---- Xatolar ----

// Backend xabarlari inglizcha. Aniq matnlar CONSOLE.md §4, §6, §7, §16 dan.
const ERROR_PATTERNS = [
  {
    test: /periodicity is used by (\d+) calendar events/i,
    message: (m) =>
      `Bu davriylik ${m[1]} ta hodisada ishlatilmoqda. Avval ularni o'chiring yoki boshqa davriylikka ko'chiring.`,
  },
  {
    test: /event with given dataset_id, periodicity_id, year, month and day_from already exists/i,
    message: () =>
      "Bu katakda shu davriylik va shu kun bilan hodisa allaqachon bor. Kunni yoki davriylikni o'zgartiring.",
  },
  {
    test: /periodicity with given code already exists/i,
    message: () => "Bu kod band — boshqa davriylikda ishlatilgan.",
  },
  {
    test: /dataset with given dataset_id is not found/i,
    message: () => "Tanlangan ma'lumot turi topilmadi (o'chirilgan bo'lishi mumkin).",
  },
  {
    test: /periodicity with given periodicity_id is not found/i,
    message: () => "Tanlangan davriylik topilmadi (o'chirilgan bo'lishi mumkin).",
  },
  {
    test: /event with given id is not found/i,
    message: () => "Hodisa topilmadi — ro'yxatni yangilang.",
  },
  {
    test: /day_from (\d+) does not exist in month (\d+) of (\d+) \(last day is (\d+)\)/i,
    message: (m) =>
      `${monthName(Number(m[2]))} ${m[3]} da ${m[1]}-kun yo'q — oyning oxirgi kuni ${m[4]}.`,
  },
  {
    test: /day_from is required unless last_day is true/i,
    message: () => "Kunni kiriting yoki «Oyning oxirgi kuni» rejimini yoqing.",
  },
  {
    test: /months must contain values between 1 and 12/i,
    message: () => "Oylar 1 dan 12 gacha bo'lishi kerak.",
  },
  {
    test: /month must be between 1 and 12/i,
    message: () => "Oy 1 dan 12 gacha bo'lishi kerak.",
  },
  {
    test: /year must be between (\d+) and (\d+)/i,
    message: (m) => `Yil ${m[1]} va ${m[2]} orasida bo'lishi kerak.`,
  },
  {
    test: /day_to/i,
    message: () => "Tugash kuni boshlanish kunidan kichik bo'lmasligi kerak (1..31).",
  },
  {
    test: /color "([^"]*)" must be a hex value/i,
    message: (m) => `«${m[1]}» — rang emas. Masalan: #3B82F6 yoki #38F.`,
  },
  {
    test: /unknown report_period_mode "([^"]*)"/i,
    message: (m) => `Noma'lum hisobot davri rejimi: «${m[1]}».`,
  },
  {
    test: /from_year/i,
    message: () => "Manba va maqsad yillari bir xil bo'lmasligi kerak.",
  },
];

// Xato javobini o'zbekcha xabarga o'giradi. Tanish bo'lmagan xabar xom
// holida qaytadi — yashirib qo'yishdan ko'ra ko'rsatgani yaxshi.
export function apiErrorMessage(error, fallback = "Kutilmagan xatolik yuz berdi") {
  const response = error?.response;
  if (!response) return "Serverga ulanib bo'lmadi";
  if (response.status === 403) return "Bu bo'lim faqat admin uchun";
  const raw = response.data?.message;
  if (!raw) return fallback;
  const matched = ERROR_PATTERNS.find((pattern) => pattern.test.test(raw));
  if (!matched) return raw;
  return matched.message(raw.match(matched.test));
}
